export default __webpack_public_path__ + "static/media/Flag_of_Canada.0bb2f364.svg";